export default class AnimeTitle {

    /**
     * AnimeTitle contructor.
     *
     * @param {AnimeTitleEnglish} english
     * @param {AnimeTitleJapanese} japanese
     */
    constructor(english, japanese) {
        this.english = english;
        this.japanese = japanese;
    }

}